export const ORDER_TYPE = {
  1: { name: "图文咨询" },
  2: { name: "电话咨询" },
  3: { name: "视频咨询" },
  4: { name: "视频服务" },
  5: { name: "图文问诊" },
  6: { name: "电话问诊" },
  7: { name: "视频问诊" },
  8: { name: "报告解读" },
  9: { name: "戒烟服务" },
  10: { name: "住院预约" },
  11: { name: "远程影像" },
  12: { name: "远程心电" },
  13: { name: "远程病理" },
  14: { name: "远程转诊" },
  15: { name: "药师审方" },
  16: { name: "在线预约" },
  99: { name: "其他" },
  100: { name: "私人医生" },
  101: { name: "私人医生" },
  102: { name: "私人医生" },
  103: { name: "私人医生" },
};

export const PATIENT_GENDER = {
  10901: "男",
  10902: "女",
};

export const ORDER_STATUS = {
  10001: "待支付",
  10002: "待接诊",
  10003: "待确认",
  // 10004: "待评价",
  10005: "已完成",
  // 10006: "退款中",
  // 10007: "已退款",
  10008: "已取消",
  10009: "已关闭",
  10010: "已退诊",
  10011: "进行中",
};

export const PRESCRIPTION_STATUS = {
  11800: "处方创建(待平台审核)",
  11801: "医生待签字(已开具处方)",
  11802: "审核药师待审核(医生已签字)",
  11803: "审核药师待签字(审核药师已审核)",
  11804: "复核药师待复核(审核药师已签字)",
  11805: "复核药师待签字(复核药师已复核)",
  11806: "待出报告(复核药师已签字)",
  11807: "已出报告",
  11808: "审核药师拒绝(驳回处方)",
  11809: "复核药师拒绝(驳回处方)",
  11810: "处方流转平台通过",
};

export const PRESCRIPTION_BUTTON = {
  11802: "审核",
  11803: "签名",
  11804: "复核",
  11805: "复核签名",
  11806: "生成报告",
  11807: "下载报告",
};

export const PATINET_GOODSID = {
  1: "图文问诊",
  2: "电话问诊",
  3: "视频问诊",
};

export const SIGNATURE_STATUS = {
  0: "提交",// 未签字
  1: "病历已生成",// 已签字
  2: "提交成功，等待签字", // 签字中
  3: "提交",// 已过期
};

export const DRUG_UNIT = {
  0	:	"盒",
  1	:	"瓶",
  2	:	"包",
  3	:	"袋",
  4	:	"片",
  5	:	"支",
  6	:	"粒",
  7	:	"丸",
  8	:	"g",
  9	:	"mg",
  10	:	"ug",
  11	:	"ml",
  12	:	"u"
};